import React, { useEffect, useState, useContext } from 'react';
import { useParams } from 'react-router-dom';
import PlayerBannerComponent from '../components/PlayerBannerComponent';
import ProgressBarsComponent from '../components/ProgressBarsComponent';
import SkillChecklistComponent from '../components/SkillChecklistComponent';
import { AuthContext } from '../auth/AuthContext';
import '../global.css';
import { fetchWithAuth } from '../utils/fetchWithAuth';

function PlayerDetailPage() {
  const { id } = useParams();
  const { token } = useContext(AuthContext);
  const [skillsByCategory, setSkillsByCategory] = useState({});
  const [progressData, setProgressData] = useState({});
  const [selectedCategory, setSelectedCategory] = useState("Underhand Passing");

  const fetchSkills = () => {
    fetch(`https://vballbackend.onrender.com/api/player/${id}/skills_by_category`, {
      headers: { Authorization: `Bearer ${token}` }
    })
      .then(res => res.json())
      .then(data => {
        setSkillsByCategory(data.skills_by_category);
        setProgressData(data.category_progress);
      });
  };

  useEffect(() => {
    fetchSkills();
  }, [id, token]);

  return (
    <div className="container" style={{ paddingTop: '2rem' }}>
      
      <div className="mb-4">
        <PlayerBannerComponent playerId={id} />
      </div>

      <div className="mb-4">
        <ProgressBarsComponent
          progress={progressData}
          onCategorySelect={setSelectedCategory}
        />
      </div>

      <div className="mb-6">
        <SkillChecklistComponent
          skills={skillsByCategory[selectedCategory] || []}
          category={selectedCategory}
          playerId={id}
          onSkillUpdated={fetchSkills}
        />
      </div>
    </div>
  );
}

export default PlayerDetailPage;
